import React, { Component } from 'react';
import {
  Button, Cutout, Fieldset,
} from 'react95';
import _ from 'lodash';

import 'animate.css';

import linksIcon from '../../resources/icons/links.gif';
import spinningGlobe from '../../resources/images/globe.gif';
import avatarPicture from '../../resources/images/myavatar2.gif';
import cat from '../../resources/images/cat.gif';

import './Links.css';
import websiteLinks from '../../resources/website-links.json';

class LinksHeader extends Component {
  render = () => (
    <span>
      <img src={ linksIcon } alt='Links' style={ { height: '15px' } }/> Biografy
    </span>
  )
}

class LinksBody extends Component {
  state = {
    linksObject: websiteLinks,
    activeTab: 0,
  }

  openRandomLink = () => {
    const { linksObject } = this.state;

    const linksList = _.flatten(linksObject.map(linkItem => linkItem.links));

    const randomLink = Object.keys(linksList).map(e => linksList[e])[
      Math.floor(Math.random() * Object.keys(linksList).map(e => linksList[e]).length)
    ];

    window.open(randomLink.url, '_blank');
  }

  handleChangeTab = value => this.setState({ activeTab: value });

  generateTabs = () => {
    const { linksObject, activeTab } = this.state;

    const tabsComponent = linksObject
      .map((linkItem, index) => (<Button
        style={ { margin: '5px', marginRight: '10px' } }
        key={ `tab_${index}` }
        active={ index === activeTab }
        onClick={ () => {
          this.handleChangeTab(index);
        } }>
        {linkItem.section}
      </Button>));

    return (<div style={ { display: 'flex', flexWrap: 'wrap', justifyContent: 'center' } }>
      {tabsComponent}
      <Button style={ { margin: '5px', marginRight: '10px' } } className='animated tada delay-1s' onClick={ this.openRandomLink }><b>Open a random website</b></Button>
    </div>);
  }

  generateTabBody = () => {
    const { linksObject, activeTab } = this.state;

    const linksList = linksObject[activeTab].links;

    const LinksListComponent = <ul>{linksList.map((link, index) => {
      const descriptionContent = link.description
        ? <span style={ { fontWeight: 'bold' } } dangerouslySetInnerHTML={ { __html: `(${link.description})` } }></span>
        : '';

      return (<li className='link-style' key={ `${link.url}_${index}` }>
        <a href={ link.url } target='_blank' rel='noopener noreferrer'>{ link.url }</a> { descriptionContent }
      </li>);
    })}</ul>;

    return ( 
      <Cutout>
        <div style={{ display:'flex',alignItems:'center', justifyContent:'center'}} className='link-list'>
        <img style={{width:'13%',height:'20%', borderRadius:'5px'}} src={ cat } />
          <img style={{margin:'50px',width:'40%',height:'40%', borderRadius:'5px'}} src={ avatarPicture } />
          <img style={{width:'13%',height:'20%', borderRadius:'5px'}} src={ cat } />
          </div>
      </Cutout>
    );
  }

  render = () => (<div style={ { marginTop: '-10px' } }>
    {/* <Cutout className='globe-container'><img src={ spinningGlobe } alt='spinning globe' className='globe-picture' /></Cutout> */}
    <Fieldset label="About Him">
      Senior Fullstack Developer with 13+ years of experience building scalable web and software solutions across SaaS, and enterprise systems. Skilled in Laravel PHP, Python FastAPI, Golang, JavaScript/TypeScript, React, Integration, API, AI and cloud infrastructure (AWS, Docker, Terraform).  Over 7 years of experience as an expatriate, successfully collaborating with multicultural teams across Asia and the Middle East. Proven track record in optimizing system performance, improving workflow efficiency, and delivering reliable software that supports business growth.  Passionate about technology and problem-solving, with a Bachelor’s degree in IT. Open to opportunities in Saudi Arabia, UAE, Qatar, and Kuwait, bringing both technical expertise and cross-cultural experience to deliver value in dynamic environments.
    </Fieldset>
    {/* <div style={ { paddingBottom: '15px', paddingTop: '10px', textAlign: 'center' } }>
      {this.generateTabs()}
    </div> */}
    <div>
      {this.generateTabBody()}
    </div>
  </div>);
}

export { LinksHeader, LinksBody };
